<template>
  <v-col style="margin-right: 2em;">
    <v-data-table
      :headers="headers"
      :items="desserts"
      :items-per-page="5"
      class="elevation-1"
    ></v-data-table>
  </v-col>
</template>


<script>
  export default {
    data () {
      return {
        headers: [
          {
            text: 'Students',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          { text: 'Computer Science', value: 'cosc' },
          { text: 'Math', value: 'math' },
          { text: 'Physics', value: 'physics' },
          { text: 'Chemistry', value: 'chemistry' },
          { text: 'English', value: 'english' },
        ],
        desserts: [
          {
            name: 'Jake Lake',
            cosc: '80%',
            math: '70%',
            physics: '70%',
            chemistry: '65%',
            english: '10%',
          },
          {
            name: 'Sam Sherber',
            cosc: '60%',
            math: '40%',
            physics: '60%',
            chemistry: '95%',
            english: '90%',
          },
          {
            name: 'Alex Roger',
            cosc: '45%',
            math: '65%',
            physics: '85%',
            chemistry: '75%',
            english: '75%',
          },
          {
            name: 'Roger Simmon',
            cosc: '45%',
            math: '55%',
            physics: '56%',
            chemistry: '78%',
            english: '65%',
          },
          {
            name: 'Alexa Samantha',
            cosc: '90%',
            math: '95%',
            physics: '85%',
            chemistry: '82%',
            english: '80%',
          },
        ],
      }
    },
  }
</script>
